import { RSAA } from 'redux-api-middleware';
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from '../../config/ApiConstants';


export function edit_admin_Action(data, token, organisationId) {
    // var searchbyname = data ? data : "";
    // console.log("data Action--",data);
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/organisation/edit-admin-details`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                'Authorization': `Bearer ${token}`,
                organisationId: organisationId,
                },
            body:JSON.stringify(data),
            types: [
                types.EDIT_ADMIN_REQUEST,
                types.EDIT_ADMIN_RECEIVE, {
                    type: types.EDIT_ADMIN_FAILURE,
                    meta: (action, state, res) => {
                        return (action, state, res);
                    }
                }]
        }
    }
}

export const reset_edit_admin_Action = () => {
    return {
        type: types.RESET_EDIT_ADMIN,
        payload: null
    }
};
